import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { usePlatformSettings } from "@/hooks/usePlatformSettings";

declare global {
  interface Window {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    fbq: any;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    _fbq: any;
  }
}

export function FacebookPixel() {
  const location = useLocation();
  const { facebookPixelId, isLoading } = usePlatformSettings();

  useEffect(() => {
    if (isLoading || !facebookPixelId) return;

    // Validate facebookPixelId to prevent XSS injection
    if (!/^[a-zA-Z0-9_-]+$/.test(facebookPixelId)) {
      console.error("Invalid Facebook Pixel ID format");
      return;
    }

    // Initialize Facebook Pixel
    const initScript = document.createElement("script");
    initScript.id = "facebook-pixel-init";
    initScript.innerHTML = `
      !function(f,b,e,v,n,t,s)
      {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
      n.callMethod.apply(n,arguments):n.queue.push(arguments)};
      if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
      n.queue=[];t=b.createElement(e);t.async=!0;
      t.src=v;s=b.getElementsByTagName(e)[0];
      s.parentNode.insertBefore(t,s)}(window, document,'script',
      'https://connect.facebook.net/en_US/fbevents.js');
      fbq('init', '${facebookPixelId}');
    `;
    document.head.appendChild(initScript);

    return () => {
      const existingInit = document.getElementById("facebook-pixel-init");
      if (existingInit) document.head.removeChild(existingInit);
    };
  }, [facebookPixelId, isLoading]);

  // Track page views on route change
  useEffect(() => {
    if (!facebookPixelId || !window.fbq) return;

    window.fbq('track', 'PageView');
  }, [location, facebookPixelId]);

  return null;
}
